var map = {
	"./iol/2004/i1-sol.md": 2788,
	"./iol/2005/i1-oldd.md": 5456,
	"./iol/2007/i3-sol.md": 7992,
	"./iol/2021/i1-sol.md": 7422,
	"./iol/2021/i2-sol.md": 2325,
	"./iol/2022/i1-sol.md": 530,
	"./iol/2022/i2-sol.md": 8892,
	"./iol/2022/i3-sol.md": 3208,
	"./iol/2022/i4-sol.md": 9768,
	"./naclo/2014/j-sol.md": 2912,
	"./naclo/2017/r-sol.md": 4305,
	"./naclo/2022/a-sol.md": 338,
	"./naclo/2022/b-sol.md": 7708,
	"./naclo/2022/d-sol.md": 2236,
	"./naclo/2022/k-sol.md": 8144,
	"./naclo/2023/o-solll.md": 5895,
	"./olcf/2023/a-fr.md": 4077,
	"./olcf/2023/b-fr.md": 6876,
	"./olcf/2023/c-fr.md": 9715,
	"./olcf/2023/d-fr.md": 1986,
	"./olcf/2023/e-fr.md": 5512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7690;